import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class PostLambdaService {
  private API_ENDPOINT = 'https://9afpgsogbk.execute-api.eu-central-1.amazonaws.com/prod/MyLambdaMicroservice';
  constructor(private httpClient: HttpClient) { }

  public saveRequest(request: any) {
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })};
    return this.httpClient.post(this.API_ENDPOINT, request, httpOptions);
    }
}
